import PlasmaBackground from '../components/PlasmaBackground';
import GridDemo          from '../components/GridDemo';
import AppStoreBadge     from '../components/AppStoreBadge';
import useReducedMotion  from '../hooks/useReducedMotion';

import coolSvg      from '../assets/images/cool.svg';
import rippleLogoSvg from '../assets/logo/ripple.svg';

export default function Hero() {
  const reducedMotion = useReducedMotion();

  return (
    <section className="section hero-section">
      <PlasmaBackground />
      <div className="container section-content">
        <div className="hero-inner">

          {/* Left */}
          <div className="hero-left">
            <div className="hero-logo-row">
              <img src={rippleLogoSvg} alt="Ripple logo mark" />
              <h1 className="wordmark">RIPPLE</h1>
            </div>
            <p className="tagline">wave · chain · logic</p>
            <p className="hero-desc">
              A wave-chain logic puzzle where every tap sends a ripple across the board.
              Clear all 25 cells to zero — in as few taps as possible.
            </p>
            <AppStoreBadge />
          </div>

          {/* Right */}
          <div className="hero-right">
            <img
              src={coolSvg}
              alt="Ripple mascot"
              className={`hero-mascot${reducedMotion ? '' : ' float-anim'}`}
            />
            <GridDemo />
          </div>

        </div>
      </div>
    </section>
  );
}
